import React from "react";
import { encodeId } from "../../../../../../../utils/hash";
import { Link } from "react-router-dom";

export default function TopSellersUsers({ userStats }) {
    return (
        <div className="card">
            <div className="card-header border-0 pb-0">
                <h2 className="fw-normal text-primary">
                    <span><i className="fa fa-caret-up"></i></span>
                </h2>
                <h4 className="card-title text-uppercase fw-normal">Monthly Top Sellers</h4>

            </div>
            <div className="card-body p-0">
                <div id="DZ_W_Todo1" className="widget-media dz-scroll height370 my-4 px-4">
                    <ul className="timeline">
                        {userStats?.monthly_top_sellers ? userStats?.monthly_top_sellers.map((seller) => (
                            <li key={seller.id}>
                                <div className="timeline-panel d-flex align-items-center" >

                                    <div className="media me-2 rounded-circle">
                                        <img
                                            alt={seller.fullname}
                                            width="50"

                                            src={`${seller?.image}` || 'https://upload.wikimedia.org/wikipedia/commons/a/ac/Default_pfp.jpg'}
                                            onError={(e) => e.target.src = 'https://upload.wikimedia.org/wikipedia/commons/a/ac/Default_pfp.jpg'}
                                        />
                                    </div>
                                    <div className="media-body">
                                        <h5 className="mb-1 text-uppercase">{seller.displayname} ({seller.sales_count})</h5>
                                        <small className="d-block text-muted">{seller.email} | {seller.phone}</small>

                                    </div>
                                    <div className="dropdown">
                                        <button type="button" className="btn btn-primary light sharp" data-bs-toggle="dropdown">
                                            <svg width="18px" height="18px" viewBox="0 0 24 24">
                                                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                    <rect x="0" y="0" width="24" height="24"></rect>
                                                    <circle fill="#000000" cx="5" cy="12" r="2"></circle>
                                                    <circle fill="#000000" cx="12" cy="12" r="2"></circle>
                                                    <circle fill="#000000" cx="19" cy="12" r="2"></circle>
                                                </g>
                                            </svg>
                                        </button>
                                        <div className="dropdown-menu dropdown-menu-end">
                                            <Link to={`/home/${encodeId(seller.id)}`} className="dropdown-item ">Dashboard</Link>
                                            <Link to={`/users/${encodeId(seller.id)}/profile`} className="dropdown-item" >View Profile</Link>
                                            <Link to={`/users/${encodeId(seller.id)}/eas`} className="dropdown-item" >Manage EAs</Link>

                                        </div>
                                    </div>


                                </div>
                            </li>
                        )) : <li className=" text-center p-4">
                            <i className="bi bi-folder-x fs-1 mb-2 text-muted"></i>
                            <div>No Sales This Month</div>
                        </li>
                        }
                    </ul>
                </div>
            </div>
        </div>
    );
}